import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { VscGithub } from "react-icons/vsc";


function Footer() {

    const currentYear = new Date().getFullYear();

    return (
      <footer className="bg-gray-800 text-white py-12">
          <div className="max-w-6xl mx-auto px-6">
              <div className="grid md:grid-cols-3 gap-8">
                  <div>
                      <h3 className="text-2xl font-bold mb-4">Summer Flowers</h3>
                      <p className="text-gray-400 mb-4">Delivering strategic project outcomes through proven methodologies and collaborative leadership.</p>
                      <div className="flex space-x-4">
                          <Link to="https://www.linkedin.com/in/summerflowers/" target="" rel="noopener noreferrer" className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-gray-600 transition-colors">
                              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                              </svg>
                          </Link>
                          <HashLink to="#contact" href="#" className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-gray-600 transition-colors">
                              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                              </svg>
                          </HashLink>
                      </div>
                  </div>
                  <div>
                      <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
                      <ul className="space-y-2 text-gray-400">
                          <li><a href="#home" className="hover:text-white transition-colors">Home</a></li>
                          <li><a href="#about" className="hover:text-white transition-colors">About</a></li>
                          <li><a href="#projects" className="hover:text-white transition-colors">Projects</a></li>
                          <li><a href="#experience" className="hover:text-white transition-colors">Experience</a></li>
                          <li><a href="#contact" className="hover:text-white transition-colors">Contact</a></li>
                      </ul>
                  </div>
                  <div>
                      <h4 className="text-lg font-semibold mb-4">Expertise</h4>
                      <ul className="space-y-2 text-gray-400">
                          <li>Project Development Lifecycle</li>
                          <li>Market Research & Strategic Planning</li>
                          <li>Risk Assessment & Mitigation</li>
                          <li>KPI Tracking & Analysis</li>
                          <li>Cross-Functional Collaboration</li>
                      </ul>
                  </div>
              </div>
              <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
                  <p>&copy; {currentYear} Beyond Sight Solutions. All rights reserved</p>
              </div>
          </div>
      </footer>
    );
  }
  
  export default Footer;